import classNames from 'classnames/bind';

import styles from './S02.module.scss';
import product01 from '../../../assets/images/products/pure/s02/product01.jpg';
import product02 from '../../../assets/images/products/pure/s02/product02.jpg';
import product03 from '../../../assets/images/products/pure/s02/product03.jpg';
import Download from '../../../components/product/Download';
import Nutrient from '../../../components/product/Nutrient';
import Products from '../../../components/product/Products';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <Products
          products={[
            { title: '2L', image: product01, text: '2L × 6개입' },
            { title: '500mL', image: product02, text: '500mL × 20개입' },
            { title: '330mL', image: product03, text: '330mL × 20개입' },
          ]}
          color="#0063c1"
        />
        <Nutrient
          data={{
            head: ['칼슘(Ca)', '칼륨(K)', '불소(F)', '마그네슘(Mg)', '나트륨(Na)'],
            body: [['9.7 ~ 14.7', '0.3 ~ 0.6', '0.0 ~ 0.2', '1.3 ~ 2.1', '5.2 ~ 8.0']],
          }}
          color="#0063c1"
        />
        <Download
          title="풀무원 퓨어는 안심하고 드실 수 있습니다!"
          names={['수질 성적 검사서']}
          files={['/static/report/Water_Report-Pure.pdf']}
          color="#0063c1"
        />
      </div>
    </div>
  );
};

export default S02;
